export default [
  {
    path: "/relatorios/clientes",
    name: "reports-clients",
    component: () => import("../views/reports/Clients.vue"),
    meta: {
      template: () => import("../templates/Base.vue"),
      protected: true,
      permissions: ["clientes"],
      viewContainer: true,
      breadcrumbs: ["reports-clients"]
    }
  }
];